<template lang="pug">
.password-input-container
    input.password-input(v-model="local" :placeholder="placeholder" :type="inputType")
    .password-show-password(v-if="allowShow" @click="toggleVisibility")
        img(:src="visibleIcon")
</template>

<script setup lang="ts">
import IconVisibilityOn from "../resources/icons/visibility_on.svg"
import IconVisibilityOff from "../resources/icons/visibility_off.svg";
import { computed, ref } from "vue";

type Props = {
    allowShow?: boolean
    modelValue: string
    placeholder?: string
}
const props = defineProps<Props>();

type Emits = {
    (e: "update:modelValue", modelValue: Props["modelValue"]): void
}
const emit = defineEmits<Emits>();

const hidePassword = ref(true);
const visibleIcon = computed(() => hidePassword.value ? IconVisibilityOff : IconVisibilityOn);
const inputType = computed(() => hidePassword.value ? "password" : "text")
const toggleVisibility = () => {
    if(props.allowShow) {
        hidePassword.value = !hidePassword.value;
    }
}


const local = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})

</script>

<style lang="scss">
.password-input-container {
    display: flex;
    width: 100%;

    .password-input{
        padding: none;
        font-weight: inherit;
        font-family: inherit;
        font-size: inherit;
        flex-grow: 1;
        border: none;
        background: none;

        &:focus{
            outline: none;
        }
    }
    .password-show-password {
        cursor: pointer;
        display: inline-flex;
        margin-right: 1rem;
    }
}
</style>